import { Text } from "~/components/Text";
import RedFlowerImage from "~/images/red-flower.png";

type Insight = {
  name: string;
  title: string;
  body: string;
};

type EventInsightProps = {
  insight?: Insight | null;
};

export function EventInsight({ insight }: EventInsightProps) {
  if (!insight) return null;

  return (
    <section className="flex items-stretch gap-2.5">
      <div className="flex h-[50px] w-[50px] flex-shrink-0 items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-butter-cream-light to-butter-cream">
        <img
          src={RedFlowerImage}
          alt=""
          aria-hidden
          className="h-[26px] w-[26px]"
        />
      </div>
      <div className="flex flex-1 items-center">
        <Text variant="secondary" size="sm" className="leading-snug">
          <Text as="span" variant="secondary" size="sm" weight="bold" className="text-butter-pink">
            {insight.title}:{" "}
          </Text>
          {insight.body.trim()}
        </Text>
      </div>
    </section>
  );
}
